// React import and other libs
import React from "react";
// Import hooks
import { apiRequests } from "../../hooks/apiRequests";
import { useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";
import { tonTx } from "../../hooks/ton_tx";
import TonWeb from "tonweb";
// Import styles
import "./Upgrade.css";
// Import of constants
import {
    AI_LEVEL,
    PRICES,
    RESTORE,
    RESTORE_PRICES,
    SUBSCRIPTION,
    TON
} from "../../consts/consts";

export const PayTonButton = (props) => {

    const [tonConnectUI] = useTonConnectUI();
    const wallet = useTonWallet();
    const { type } = props;

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const handleTransaction = async (id, subscription, ai_level, token) => {

        const { checkTonTx } = apiRequests();
        const { getUpgradeSubscriptionTonTx, getUpgradeAiLevelTonTx, getRestoreEnergyTonTx } = tonTx();

        if (!wallet) {
            props.setNotification("No wallet connected. Please\nconnect your wallet first.", 2000);
            return;
        }

        let transaction = null;
        if(type === SUBSCRIPTION) {
            transaction = await getUpgradeSubscriptionTonTx(id.toString(), subscription);
        } else if (type === AI_LEVEL) {
            transaction = await getUpgradeAiLevelTonTx(id.toString(), (parseInt(ai_level)+1).toString());
        } else if (type === RESTORE) {
            transaction = await getRestoreEnergyTonTx(id.toString(), parseInt(ai_level).toString(), subscription);
        } else {
            props.setNotification("Unknown type. Try again.", 2000);
        }

        let reqBody;
        let isTxSent = false;
        try {
            let result = await tonConnectUI.sendTransaction(transaction);
            props.setNotification("Transaction sent successfully!", 2000);
            await sleep(2000);
            isTxSent = true;

            const bocCellBytes = await TonWeb.boc.Cell.oneFromBoc(TonWeb.utils.base64ToBytes(result.boc)).hash();
            const hashHex = TonWeb.utils.bytesToHex(bocCellBytes);
            reqBody = {
                'id': id,
                'request_type': "ACCOUNT_UPGRADE",
                'token': token,
                'hash': hashHex
            }
        } catch (error) {
            if (error.name === "UserRejectsError") {
                props.setNotification("Transaction cancelled.\nPlease try again.", 2000);
            } else {
                props.setNotification("Transaction failed.\ Please try again.", 2000);
            }
        }

        if(!isTxSent) return;

        let resp;
        let isDone = false;
        for (let i = 0; i < 10; i++) {
            try {
                props.setNotification("Checking transaction...", 1500);
                await sleep(1.5 * 1500);
                resp = await checkTonTx(reqBody);
            } catch (error) {
                if(error.message === "403") {
                    props.setNotification("Invalid username/token. Refresh\npage and try again.", 2000);
                } else if (error.message === "400") {
                    props.setNotification("Invalid request. Try again.", 2000);
                } else if (error.message === "540") {
                    props.setNotification("Transaction not found.\nRetrying in 10 seconds.\n Please wait. Attempt " +
                        (i+1).toString()+"/10", 10000);
                } else {
                    props.setNotification("Invalid request or\ntransaction not found.\nRetrying in 10 seconds.\n Please wait. Attempt " +
                        (i+1).toString()+"/10", 10000);
                }
                if((i+1) === 10) {
                    props.setNotification("Transaction not found.\n" +
                        "or an error occurred.\n" +
                        "After the transaction is published on\n" +
                        "the blockchain, it will be activated\n" +
                        "in the app within 10 minutes.\n" +
                        "Please log back into the app\n" +
                        "after the specified time.", 5000);
                }
                isDone = false;
            }
            if (resp !== undefined && resp.hasOwnProperty('result')) {
                isDone = true;
            }
            if (isDone) {
                props.setNotification("Transaction found.\nAccount upgraded.", 2000);
                props.changeUserData(resp);
                break;
            }
            if(isDone === false) {
                await sleep(10 * 1000);
            }
        }
        if (isDone === false) {
            props.setNotification("Transaction not found.\nPlease contact support.", 5000);
        }
    };

    if(type === SUBSCRIPTION) {
        const buttonName = props.subscription[0].toUpperCase() + props.subscription.slice(1);
        return (
            <div className={"upgrade__button"} onClick={() => handleTransaction(props.tgid, props.subscription, props.aiLevel, props.token)}>
                <span className="upgrade__button-text">Upgrade to {buttonName} ({PRICES[buttonName.toUpperCase()][TON].toString()} TON)</span>
            </div>
        );
    } else if (type === AI_LEVEL) {
        const aiLevelInt = parseInt(props.aiLevel);
        if(aiLevelInt >=5) {
            return null;
        } else {
            return (
                <div className={"upgrade__button"} onClick={() => handleTransaction(props.tgid, props.subscription, props.aiLevel, props.token)}>
                <span className="upgrade__button-text">
                    Upgrade to AI level {(aiLevelInt + 1).toString()} ({PRICES["AI_LEVEL_"+(aiLevelInt + 1).toString()][TON]} TON)</span>
                </div>
            );
        }
    } else if (type === RESTORE) {
        const aiLevelInt = parseInt(props.aiLevel);
        return (
            <div className={"upgrade__button"} onClick={() => handleTransaction(props.tgid, props.subscription, props.aiLevel, props.token)}>
                <span className="upgrade__button-text">Restore energy ({RESTORE_PRICES["AI_LEVEL_"+aiLevelInt.toString()][TON]} TON)</span>
            </div>
        );
    } else {
        return null;
    }

};